import React, { useState, useEffect } from 'react';
import { useHistory, useParams} from "react-router-dom";
import axios from 'axios';
import UserMenu from './UserMenu';
import Sidebar from './Sidebar';
import Alert from './Alert';
import { Warning, AddUser} from '../components/icons/svgIcons';
import { ReactComponent as IconInboundSearch } from './icons/inboundSearch.svg';

import './css/Home.css';

const ClaroDicomClientsSearch = (props) => {
    const { inboundQueue } = useParams(); 
    const { phone } = useParams(); 

    const [clients, setClients] = useState([]); 
    const [searchValue, setSearchValue] = useState(phone); 
    const [searchKey, setSearchKey] = useState('PHONE'); 
    const [lastSearchValue, setLastSearchValue] = useState(null); 
    const [lastSearchKey, setLastSearchKey] = useState(null); 
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const history = useHistory();

    //CONFIG
    const [defaultAssignmentId, setdDefaultAssignmentId] = useState("68f9620a2e95138d1548e541"); 
    const [defaultCampaignId, setDefaultCampaignId] = useState("68f964f54cfb6e112bc2c1d8");
    const [defaultCompanyId, setDefaultCompanyId] = useState(125); 
    const [defaultCodeCounter, setDefaultCodeCounter] = useState("CORRELATIVE_JUNGLABET"); 

    useEffect(() => {
        getClientsSearch();
    }, []);

    const getClientsSearch = (campaign) => {

        let serviceParams = { companyId: defaultCompanyId }
        if (searchValue) {
            serviceParams.searchValue=searchValue.trim();
            serviceParams.searchKey=searchKey;
        }

        setLoading(true);

        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData')); 
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/clientsWAByKey`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: serviceParams
        };

        axios(options).then((response) => {
            setClients(response.data); 
            setLoading(false);

            setLastSearchKey(serviceParams.searchKey);
            setLastSearchValue(serviceParams.searchValue);
        })
        .catch((error) => {
            console.log("Error:", error.message);
            setError(error.message);
            setLoading(false);
        });
    }

    const handleSearchChange = (event) => {
        setSearchValue(event.target.value);
    }

    const search = () => {
        getClientsSearch();
    }

    const createNewClient = () => {
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/createClientWA`,
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: {
                companyId: defaultCompanyId,
                codeCounter: defaultCodeCounter,
                genericAssignmentId: defaultAssignmentId, 
                genericCampaignId: defaultCampaignId
            }
        };
        
        axios(options).then(response => {
            if (response.status === 200) {
                history.push(`/${defaultCampaignId}/${response.data.newClientId}`); 
            }
        })
        .catch(function (error) {
            setError(error.response.data);
            setLoading(false);
        });
    }

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus}/>
            <div className="main">
                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading?'loading':''}><IconInboundSearch/>Inbound Claro Dicom</h1>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues}/>
                </div>

                {error?(
                    <Alert className="error mgb20">Error: {error}</Alert>
                ):null}

                <div className="flexWrapper">
                <div className="searchWrapper">
                    <input type="search" name="q" placeholder="Ingrese un patrón de búsqueda..." size="60" onChange={handleSearchChange}/>
                    <select className='simple' name='searchKey' onChange={(e)=>setSearchKey(e.target.value)}>
                        <option value="PHONE">Telefono</option>
                        <option value="RUT">Rut</option>
                        <option value="NAME">Nombre</option>
                    </select>
                    <button className='default' onClick={() => search()}>Buscar</button>
                    
                </div>
                    <button className='default autowidth' onClick={() => { createNewClient() }}><AddUser/> Crear nuevo cliente</button>

                </div>

                <div className="tableWrapper">
                    <table className="fullWidth">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>clientId</th>
                                <th>Rut</th>
                                <th>Teléfono</th>
                                <th>Nombre cliente</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {clients.map((listValue, index) => {
                                return (
                                    <tr key={index}>
                                        <td align="right">{index+1}</td>
                                        <td>{listValue.clientId}</td>
                                        <td>{listValue.clientId}</td>
                                        <td>{listValue.contacto.phones[0]}</td>
                                        <td>{listValue.clienteNombre}</td>
                                        <td>
                                            <a className="link" onClick={() => { history.push("/" + defaultCampaignId + "/" + listValue.clientId + "/" + listValue.contacto.phones[0]); }}>Seleccionar</a>
                                        </td>
                                    </tr>  
                                );      
                            })}   
                        </tbody>            
                    </table>
                    
                    {clients.length===0 && lastSearchValue!== null && !loading?(
                        <p className='notFound'><Warning width='20px'/>No se encontraron registros con el filtro especificado</p>
                    ):null}

                </div>

            </div>
        </div>
    );
}

export default ClaroDicomClientsSearch;